module.exports = __webpack_public_path__ + "static/img/frontpage2.90958d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frontpage2.jpg
// module id = 2XtP
// module chunks = 0